import { useEffect } from "react";
import api from "../lib/api";

export function SponsoredCard({ ad, label = "Sponsored", compact = false }) {
  useEffect(() => {
    if (ad?.id) api.post(`/ads/${ad.id}/impression`).catch(() => {});
  }, [ad?.id]);

  if (!ad) return null;

  const onClick = () => { if (ad.id) api.post(`/ads/${ad.id}/click`).catch(() => {}); };

  return (
    <a
      href={ad.destination_url}
      target="_blank"
      rel="noopener noreferrer sponsored"
      onClick={onClick}
      data-testid={`sponsored-card-${ad.id}`}
      className="block border border-gray-200 bg-white hover:shadow-md transition-shadow group"
    >
      <div className="flex items-center justify-between px-3 pt-2">
        <span className="text-[10px] uppercase tracking-widest font-bold text-gray-500 flex items-center gap-1">
          <span className="w-1.5 h-1.5 bg-pti-red inline-block" aria-hidden="true" /> {label}
        </span>
        <span className="text-[10px] text-gray-400">{ad.category}</span>
      </div>
      {ad.image && !compact && (
        <div className="aspect-video overflow-hidden bg-gray-100 mt-2">
          <img src={ad.image} alt={ad.headline} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        </div>
      )}
      <div className="p-3">
        <div className="flex items-center gap-2 mb-1">
          {ad.logo && <img src={ad.logo} alt="" className="w-5 h-5 object-contain" />}
          <span className="text-xs font-bold text-gray-700">{ad.brand_name}</span>
        </div>
        <h4 className="font-display font-bold text-base leading-tight group-hover:text-pti-red transition-colors">{ad.headline}</h4>
        <p className="text-sm text-gray-600 mt-1 line-clamp-2">{ad.description}</p>
        <span className="inline-block mt-2 text-xs font-bold text-pti-red">{ad.cta} →</span>
      </div>
    </a>
  );
}
